// AUTO-GENERATED from package.json by scripts/generate-version.mjs — do not edit.
export const APP_VERSION = '0.7.1';
